import { Component, OnInit } from '@angular/core';

import {  ProfileDataService } from '../../Services/index';

//import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';

//import { ControlGroup } from '@angular/Common';
import { Role } from '../../Models/roles';

import {SelectItem, DataTableModule, ButtonModule, DialogModule, InputTextModule, MessagesModule, CalendarModule, Message} from 'primeng/primeng';

@Component({
    //moduleId: module.id,
    templateUrl: './Permissions.html'
})

export class PermissionsComponent implements OnInit {


    displayDialog: boolean;

    role: PrimeRole = new PrimeRole();

    selectedTeamMemberProfile: PrimeRole;

    newRole: boolean;

    roles: PrimeRole[];

    msgs: Message[] = [];

    userform: PrimeRole;

    submitted: boolean;


    constructor(private profiledataservice: ProfileDataService, private fb: FormBuilder) { }

    ngOnInit() {
        this.userform = this.fb.group({
            'name': ["", Validators.required],
            'description': ["", Validators.required],
            'notes': ["", Validators.required]
        });
        //this.profiledataservice.GetTeamMembers(0).subscribe(profile => this.teamMemberProfile = profile);

        this.profiledataservice.GetRoles().subscribe((lstprofiles: Role[]) =>
            this.roles = lstprofiles

        );
    }

	showDialogToAdd(editrole: any) {


        this.userform = this.fb.group({
            'name': ["", Validators.required],
            'description': ["", Validators.required],
            'notes': ["", Validators.required]
        });
        // alert(editrole)
        console.log(editrole)
        this.newRole = true;
        if (editrole != null) {
            this.role = editrole;
            this.newRole = false;
            editrole = null;
        } else {
            this.role = new PrimeRole();
        }

        //this.role = new PrimeRole();
        console.log(PrimeRole);
        this.displayDialog = true;
    }
    save() {


        if (this.newRole)
            this.roles.push(this.role);
        else
            this.roles[this.findSelectedLeaveTypeIndex()] = this.role;

        this.role = null;
        this.displayDialog = false;
    }

    delete() {
        this.userform = this.fb.group({
            'name': ["", Validators.required],
            'description': ["", Validators.required],
            'notes': ["", Validators.required]
        });
        //console.log(1);
        this.profiledataservice.DeleteProfile(this.role);


        //this.leaveTypes.splice(this.findSelectedLeaveTypeIndex(), 1);
        this.role = null;
        this.displayDialog = false;
    }

	onRowSelect(event: any) {

        this.newRole = false;
        console.log(event.data);
        this.role = this.cloneLeaveType(event.data);
        //console.log(this.role);
        this.showDialogToAdd(this.role);
    }

    cloneLeaveType(c: Role): PrimeRole {
        let editrole = new PrimeRole();
        for (let prop in c) {
            editrole[prop] = c[prop];
        }
        return editrole;
    }

    findSelectedLeaveTypeIndex(): number {

        return this.roles.indexOf(this.selectedTeamMemberProfile);
    }


    onSubmit(value: string) {
        //alert(1)
        if (this.newRole) {
            this.profiledataservice.AddRole(this.role);

            this.roles.push(this.role);
        }
        else {
            this.profiledataservice.AddRole(this.role);

            this.roles[this.findSelectedLeaveTypeIndex()] = this.role;
        }

        this.role = null;
        this.displayDialog = false;


        this.submitted = true;
        this.msgs = [];
        this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Roles save successfully !' });
    }

}



class PrimeRole implements Role {
	constructor(public id?: any, public name?: any, public description?: any, public notes?: any
    ) { }
}




// WEBPACK FOOTER //
// ./src/app/Components/Permissions/Permissions.ts